import { Injectable, inject } from '@angular/core';
import { map, of } from 'rxjs';
import {
    ApiAgentUser,
    ApiPickupLocation,
    ApiShip,
    fromApiAgentUsers,
    fromApiPickupLocations,
    fromApiShips,
    ApiTourInventoryDTDAssignmentModel,
    ApiTourInventoryDTDAssignmentPrelimDetails,
    ApiTourInventoryDTDAssignmentDetails,
    ApiTourInventoryDTDAssignmentData,
    ApiPrelimListData,
    ApiDTDAssignmentPrelimList,
    fromApiAssignments,
    ApiAssignment,
} from '../../models';
import {
    GetAgentUsers,
    GetAllUniqueShipCompaniesByCompanyId,
    GetPickupLocation,
} from './mocks';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiRoutes } from '../../constants';
import { formatDate } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class DtdApiService {
    http = inject(HttpClient);
    getGuides(companyUniqueId: string, includeInactiveUsers: boolean = false) {
        let params = new HttpParams();
        params = params.append('companyUniqueId', companyUniqueId);
        params = params.append('includeInactiveUsers', includeInactiveUsers);
        // return of(<ApiGuide[]>GetGuides).pipe(
        return this.http
            .get<any>(`${ApiRoutes.dtd}GetGuides`, { params: params })
            .pipe(map((res) => res.data));
        // .pipe(map((guides) => fromApiGuides(guides)));
    }

    getAssignmentList(
        companyUniqueId: string,
        assignmentDate: Date = new Date()
    ) {
        const formattedAssignmentDate = formatDate(
            assignmentDate,
            'YYYY-MM-dd',
            'en-US'
        );
        return this.http
            .post<{ data: ApiAssignment[] }>(
                `${ApiRoutes.dtd}GetDTDAssignmentList`,
                {
                    companyId: companyUniqueId,
                    assignmentDate: formattedAssignmentDate,
                }
            )
            .pipe(map((res) => fromApiAssignments(res.data)));
    }

    getAgentUsers(cuid: string) {
        return of(<ApiAgentUser[]>GetAgentUsers).pipe(
            map((agentUsers) => fromApiAgentUsers(agentUsers))
        );
    }

    getPickupLocations(cuid: string) {
        return of(<ApiPickupLocation[]>GetPickupLocation).pipe(
            map((pickupLocations) => fromApiPickupLocations(pickupLocations))
        );
    }

    getShips(cuid: string) {
        return of(<ApiShip[]>GetAllUniqueShipCompaniesByCompanyId).pipe(
            map((ships) => fromApiShips(ships))
        );
    }

    saveTourInventoryDTDAssignmentDetailsBulk(
        data: ApiTourInventoryDTDAssignmentModel[]
    ) {
        return this.http.post<{
            success: boolean;
            data: ApiTourInventoryDTDAssignmentDetails[];
            error?: string;
        }>(`${ApiRoutes.dtd}SaveTourInventoryDTDAssignmentDetailsBulk`, data);
    }

    getDTDAssignmentPrelimList(data: ApiPrelimListData) {
        return this.http.post<{
            success: boolean;
            data: ApiDTDAssignmentPrelimList[];
            error?: string;
        }>(`${ApiRoutes.dtd}GetDTDAssignmentPrelimList`, data);
    }

    saveTourInventoryDTDAssignmentPrelimDetailsBulk(
        userId: string,
        data: ApiTourInventoryDTDAssignmentData[]
    ) {
        let params = new HttpParams();
        params = params.append('userId', userId);
        return this.http.post<{
            success: boolean;
            data: ApiTourInventoryDTDAssignmentPrelimDetails[];
            error?: string;
        }>(
            `${ApiRoutes.dtd}SaveTourInventoryDTDAssignmentPrelimDetailsBulk`,
            data,
            {
                params: params,
            }
        );
    }

    openTourInventoryDTDAssignment(userId: string) {
        let params = new HttpParams();
        params = params.append('userId', userId);
        return this.http.post<{
            success: boolean;
            data: number[];
            error?: string;
        }>(`${ApiRoutes.dtd}OpenTourInventoryDTDAssignment`, {
            params: params,
        });
    }
}
